import { Link } from '@inato/ui';
import type React from 'react';

import { InatoLogo } from '@components/Logo/InatoLogo';
import { BreadcrumbPlaceholder } from '../BreadcrumbPlaceholder';
import { Footer } from '../Footer';
import { MainLayoutContainer } from './MainLayoutContainer';

export const ErrorPagesLayout = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <MainLayoutContainer>
    <Header />
    <div className="max-w-site-app-layout-medium px-l pt-l desktop:px-xxl mx-auto flex w-stretch flex-1 flex-col">
      <BreadcrumbPlaceholder />
      <div className="flex w-full flex-1 flex-col">{children}</div>
    </div>
    <Footer className="max-w-site-app-layout-medium px-l pb-m desktop:px-xxl mx-auto mt-auto w-stretch pt-[80px]" />
  </MainLayoutContainer>
);

const Header = () => (
  <div className="z-header bg-background-white shadow-header w-full">
    <div className="h-header max-w-site-app-layout-medium px-l desktop:px-xxl m-auto flex items-center">
      <Link href="/">
        <InatoLogo height={20} width={59} />
      </Link>
    </div>
  </div>
);
